import {
  OWN_CAPABILITY_HINTS,
  OWN_CAPABILITY_LABELS,
  OWN_KIND,
  OWN_MODULE_HINTS,
  OWN_MODULE_TITLES,
  OWN_TITLE,
  emptyOwnSettings,
  validateOwnSettings,
} from './model/settings'
import { OwnConnectionForm } from './ui/OwnConnectionForm'

/**
 * Форма подключения источника «Собственный источник» для реестра Platform. Объект той же формы, что `ConnectionFormExtension`
 * пакета `platform-ui`: пакеты друг друга не импортируют, совместимость проверяет компилятор при регистрации в
 * `apps/web/src/composition/connectionForms.ts`. Секрета у вида нет.
 */
export const ownConnectionForm = {
  kind: OWN_KIND,
  title: OWN_TITLE,
  /** Метка вида на вкладках разделов (UI-SECTIONS). */
  shortTitle: 'Свой',
  /** Слово вида на плитке источника РМК (UI-RMK-FLOW 3.4). */
  sourceNoun: 'Собственный источник',
  /** Цвет вида — палитра источника ui-kit, та же, что у рамки окон пакета. */
  tone: 'own',
  /** Строка на плитке окна «Добавить источник». */
  summary: 'Свои номенклатура, цены, РМК и чеки без внешней системы.',
  capabilityLabels: OWN_CAPABILITY_LABELS,
  capabilityHints: OWN_CAPABILITY_HINTS,
  moduleTitles: OWN_MODULE_TITLES,
  moduleHints: OWN_MODULE_HINTS,
  secret: null,
  emptySettings: emptyOwnSettings,
  validate: validateOwnSettings,
  Form: OwnConnectionForm,
} as const
